import {html} from 'uhtml';
import DarkModeManager from 'Components/00-basics/dark-mode';

const manager = new DarkModeManager();
const targetElement = document.querySelector('.menu--legal');

const states = {
  light: 'Light',
  dark: 'Dark',
  auto: 'Auto'
};

function createToggleButton() {
  const stateKeys = Object.keys(states);
  const getStateLabel = () => states[manager.getUserPreference()];

  const currentState = html.node`
    <span>${getStateLabel()}</span>
  `;

  const clickHandler = () => {
    manager.setUserPreference(stateKeys[(stateKeys.indexOf(manager.getUserPreference()) + 1) % 3]);
    currentState.innerHTML = getStateLabel();
  }

  const button = html`
    <button class="unstyled" title="Toggle light/dark mode" onclick=${clickHandler}>
      <i class="fa-solid fa-circle-half-stroke" aria-hidden="true"></i>
      <span class="visually-hidden">Light/Dark toggle:</span>
      ${currentState}
    </button>
  `;

  return button;
}

if (targetElement) {
  targetElement.appendChild(html.node`<li>${createToggleButton()}</li>`);
}
